<template>
    <v-dialog v-model="shows" width="600">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card :disabled="disabled">
            <v-card-title>상품 {{ isCreated ? "등록" : "수정" }}</v-card-title>
            <v-divider />
            <v-row no-gutters class="pa-3">
                <v-col cols="4">
                    <image-input v-model="form.image" outlined flat width="150" :aspect-ratio="1 / 1" />
                </v-col>
                <v-col cols="8" class="pt-3">
                    <v-row>
                        <v-col cols="4">
                            <v-text-field v-model="form.index" type="number" label="순서" outlined dense hide-details="auto" />
                        </v-col>
                        <v-col cols="8">
                            <v-text-field v-model="form.subject" label="제목" outlined dense hide-details="auto" />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="form.url" label="url" placeholder="/gshop/brand/giftcards?_category=xxxxxx&_brand=xxxxxx" outlined dense hide-details="auto" rows="3"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider />
            <v-card-actions>
                <v-switch v-model="form.shows" class="ma-0 ml-2" label="노출" :inset="true" hide-details="auto" />
                <v-spacer />
                <v-btn @click="() => (shows = false)">취소</v-btn>
                <v-btn color="primary" v-bind="{ loading }" @click="save">{{ isCreated ? "등록" : "수정" }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import ImageInput from "../image-input.vue";
const initPartner = (partner = {}) => ({
    ...partner,
    index: partner?.index || 0,
    subject: partner?.subject || "",
    image: partner?.image || "",
    url: partner?.url || "",
    shows: partner?.shows || false,
});
export default {
    components: {
        ImageInput,
    },
    props: {
        value: { type: Object, default: initPartner },
        disabled: { type: Boolean, default: false },
    },
    data: () => ({
        shows: false,
        loading: false,

        form: initPartner(),
    }),
    computed: {
        isCreated() {
            return !this.value._id;
        },
    },
    mounted() {
        this.sync();
    },
    methods: {
        sync() {
            this.form = initPartner(this.value);
        },

        async search() {
            if (this.isCreated) return;
            if (this.loading) return;
            this.loading = true;
            try {
                let { partner } = await api.console.common.partners.get({ _id: this.value._id });

                this.form = initPartner(partner);
            } catch (error) {
                alert(error);
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (this.loading) return;
            this.loading = true;
            try {
                let { image, ...form } = this.form;
                let { put, post } = api.console.common.partners;

                let { partner } = await (this.isCreated ? post : put)(form);

                if (image instanceof File) {
                    await api.console.common.partners.image.post(partner._id, image);
                }
                alert("저장되었습니다.");
                this.shows = false;
                this.$emit("update");
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        shows() {
            this.sync();
            if (this.isCreated) this.form.index = this.totalCount + 1;
            if (this.shows) this.search();
        },
    },
};
</script>

<style>
</style>